import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

import { Icon } from '~/components/Icon'
import { Link } from '~/components/Link'

export function PlayButton({ gameEndpoint, from }: { gameEndpoint: string; from?: string }): React.ReactElement {
  const { t } = useTranslation('games')

  const router = useRouter()

  const buttonClass = 'px-4 py-2 flex items-center space-x-1 border border-purple rounded text-2.5 font-medium'
  const buttonHoverClass = 'hover:bg-purple-light'

  const handleGameEndPoint = (e: Event): void => {
    e.preventDefault()

    router.push(
      {
        pathname: gameEndpoint,
        query: { from },
      },
      gameEndpoint,
    )
  }

  return (
    <Link onClick={handleGameEndPoint} to={gameEndpoint}>
      <button className={`float-right ${buttonClass} ${buttonHoverClass}`}>
        <Icon className="text-purple text-sm" name="play_circle" />
        <div>{t('play')}</div>
      </button>
    </Link>
  )
}
